import styled from 'styled-components'

export const ResendSignatureEmailForm = styled.form`
  margin-top: 24px;
  display: flex;
  align-items: flex-start;
  justify-content: center;

  input {
    margin: 0;
  }

  > button {
    padding: 11px 16px;
    margin: 0 0 0 24px;
    display: flex;
    white-space: nowrap;
    align-items: center;
    justify-content: center;

    svg {
      margin-left: 10px;

      path {
        stroke: ${({theme}) => theme.accent};
      }
    }
  }

  @media (max-width: ${({theme}) => theme.breakpoints.xxl}) {
    flex-direction: column;
    > button {
      margin: 12px 0 0 0;
      width: 100%;
    }
  }
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`
